<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="title">Birthday parties at georgian bowl</div>
  <div class="description">
    <span class="green">Bowling, Arcade, Food & Fun for Up to 8 Kids!</span>
  </div>
  <div class="type">
    <span class="label">🎉 Ultimate Bowling party</span>
    <span class="value">Includes pizza, fun cards, lootbags, drinks, party swag & more!</span>
  </div>
  <div class="type">
    <span class="label">🎉 Pin Party (Bowling Only) </span>
    <span class="value">A simpler package with bowling, drinks, fun cards & lootbag!</span>
  </div>


  <div class="link">
    <span class="label">Learn More</span>
    <app-qrcode content="https://oon.gl/X6V2md" [size]="214"/>
  </div>
</div>
